import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCompCode,
  getDILocations,
  getPlannedCartonGraph,
  getPlannedCartonReport,
  getPlannedReceivedGraph,
  getPlannedReceivedReport,
  getPlannedReceivedTable,
} from "../api/cartonSummary";
import { downloadReportForS3Link } from "../api/downloadFile";
import axios from "axios";

export const fetchPlannedReceivedTable = createAsyncThunk(
  "cartonSummary/fetchPlannedReceivedTable",
  async (params) =>
    getPlannedReceivedTable(
      params?.startDate,
      params?.endDate,
      params?.location,
      params?.compCode,
      params?.page,
      params?.limit
    )
);

export const fetchPlannedReceivedGraph = createAsyncThunk(
  "cartonSummary/fetchPlannedReceivedGraph",
  async (params) =>
    getPlannedReceivedGraph(
      params?.startDate,
      params?.endDate,
      params?.location,
      params?.compCode,
      params?.page
    )
);

export const fetchPlannedCartonGraph = createAsyncThunk(
  "cartonSummary/fetchPlannedCartonGraph",
  async (params) =>
    getPlannedCartonGraph(
      params?.startDate,
      params?.endDate,
      params?.location,
      params?.compCode,
      params?.dayRange
    )
);

export const fetchPlannedReceivedReport = createAsyncThunk(
  "cartonSummary/fetchPlannedReceivedReport",
  async (params) =>
    getPlannedReceivedReport(
      params?.startDate,
      params?.endDate,
      params?.location,
      params?.compCode,
      params?.requestId
    )
      .then((res) => res)
      .catch((err) => err)
);

export const fetchPlannedCartonReport = createAsyncThunk(
  "cartonSummary/fetchPlannedCartonReport",
  async (params) =>
    getPlannedCartonReport(
      params?.startDate,
      params?.endDate,
      params?.location,
      params?.compCode,
      params?.dayRange
    )
);

export const fetchCompCodes = createAsyncThunk(
  "cartonSummary/fetchCompCodes",
  async () => getCompCode()
);

export const fetchDILocation = createAsyncThunk(
  "cartonSummary/fetchDILocation",
  async () => getDILocations()
);

export const fetchDownloadReportS3Link = createAsyncThunk(
  "cartonSummary/fetchDownloadReportS3Link",
  async (params) =>
    downloadReportForS3Link(params?.requestId).then((res) => res)
);

export const cartonSummarySlice = createSlice({
  name: "cartonSummary",
  initialState: {
    tableData: null,
    graphData: null,
    plannedGraphData: null,
    plannedReceivedReport: null,
    plannedCartonReport: null,
    loading: false,
    compCodesData: null,
    diLocationsData: null,
    cartonSummaryReportError: false,
    cartonSummaryDownloadFileResponse: null,
  },
  reducers: {
    resetCartonSummaryReportError: (state, { payload }) => {
      state.cartonSummaryReportError = false;
    },
    resetCartonSummaryDownloadFileResponse: (state, { payload }) => {
      state.cartonSummaryDownloadFileResponse = false;
    },
  },
  extraReducers: {
    [fetchPlannedReceivedTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPlannedReceivedTable.fulfilled]: (state, { payload }) => {
      state.tableData = payload;
      state.loading = false;
    },
    [fetchPlannedReceivedTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPlannedReceivedGraph.fulfilled]: (state, { payload }) => {
      state.graphData = payload;
    },
    [fetchPlannedCartonGraph.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPlannedCartonGraph.fulfilled]: (state, { payload }) => {
      state.plannedGraphData = payload;
      state.loading = false;
    },
    [fetchPlannedCartonGraph.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPlannedReceivedReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPlannedReceivedReport.fulfilled]: (state, { payload }) => {
      if (axios.isAxiosError(payload)) state.cartonSummaryReportError = true;
      else {
        state.cartonSummaryReportError = false;
        state.plannedReceivedReport = payload;
      }

      state.loading = false;
    },
    [fetchPlannedReceivedReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPlannedCartonReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchPlannedCartonReport.fulfilled]: (state, { payload }) => {
      state.plannedCartonReport = payload;
      state.loading = false;
    },
    [fetchPlannedCartonReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchCompCodes.fulfilled]: (state, { payload }) => {
      state.compCodesData = payload;
    },
    [fetchDILocation.fulfilled]: (state, { payload }) => {
      state.diLocationsData = payload;
    },
    [fetchDownloadReportS3Link.fulfilled]: (state, { payload }) => {
      state.cartonSummaryDownloadFileResponse = payload;
    },
  },
});

export default cartonSummarySlice.reducer;
export const {
  resetCartonSummaryReportError,
  resetCartonSummaryDownloadFileResponse,
} = cartonSummarySlice.actions;
